import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { BarType } from 'store/reducers/visualisations/types';

export const typeOptions: (disabled: boolean) => SettingsRadioItem<BarType>[] = (disabled) => [
  { value: 'pile', label: 'Абсолютные значения', disabled },
  { value: 'nominated', label: 'Номинированная на 100%', disabled },
];
